import { render, staticRenderFns } from "./purse-box.vue?vue&type=template&id=50b371a5&scoped=true"
import script from "./purse-box.js?vue&type=script&lang=js&external"
export * from "./purse-box.js?vue&type=script&lang=js&external"
import style0 from "./purse-box.less?vue&type=style&index=0&id=50b371a5&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b371a5",
  null
  
)

export default component.exports